import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { PopupInterface } from 'common/types/entities/popup-interface'
import { useManagement, usePage } from 'publisher/store'
import managementSelectors from 'publisher/store/management/managementSelectors'
import pageSelectors from 'publisher/store/page/pageSelectors'
import { showPopup } from '../actionsManagement'
import { closeCookieExists } from '../utils/cookie'
import { dispatchPopupOpenedCustomEvent } from '../utils/popupUtils'

export const useOnLoadVisibility = (
  pageId: number,
  popupId: string,
  delay: number,
) => {
  const [count, setCount] = useState(0)
  const activePopupId = useManagement(managementSelectors.getActivePopupId)
  const popupEntity = usePage(page =>
    pageSelectors.getEntityById(page, popupId),
  ) as PopupInterface | OldEntityInterface
  const isAnyPopupOpened = Boolean(activePopupId)
  const dispatch = useDispatch()
  const hasCloseCookie = closeCookieExists(pageId, popupId)

  const popupAttrId =
    (popupEntity as PopupInterface).htmlAttrId ||
    (popupEntity as OldEntityInterface)?.options?.attrId

  useEffect(() => {
    if (hasCloseCookie) {
      return
    }
    if (count >= delay) {
      if (isAnyPopupOpened) {
        return
      } else {
        dispatch(showPopup(popupId))
        // use small timeout in order to render popup
        dispatchPopupOpenedCustomEvent(popupAttrId)
      }
    }

    const timeout = setTimeout(() => {
      setCount(count => count + 1)
    }, 1000)

    return () => clearTimeout(timeout)
  }, [
    count,
    isAnyPopupOpened,
    delay,
    dispatch,
    hasCloseCookie,
    popupId,
    popupAttrId,
  ])
}
